import loadable from "@loadable/component";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

import Layout from "components/Layout/Layout";

import AuthRedirect from "./AuthRedirect";
import RouterErrorBoundary from "./RouterErrorBoundary";

const AboutUs = loadable(() => import("pages/about-us"));
const Account = loadable(() => import("pages/account/account"));
const Apply = loadable(() => import("pages/apply"));
const BugReport = loadable(() => import("pages/bug-report"));
const Chat = loadable(() => import("pages/chat"));
const ConfirmPassword = loadable(() => import("pages/confirm-password"));
const ContactUs = loadable(() => import("pages/contact-us"));
const Default = loadable(() => import("pages/default/default"));
const Faq = loadable(() => import("pages/faq"));
const ForgotPassword = loadable(() => import("pages/forgot-password"));
const Index = loadable(() => import("pages/index/index"));
const Privacy = loadable(() => import("pages/privacy"));
const Recs = loadable(() => import("pages/recs/recs"));
const SignIn = loadable(() => import("pages/signin"));
const SignUp = loadable(() => import("pages/signup"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />} ErrorBoundary={RouterErrorBoundary} path="/">
      <Route element={<Index />} ErrorBoundary={RouterErrorBoundary} index />
      <Route element={<AuthRedirect />} ErrorBoundary={RouterErrorBoundary} path="__/auth/action" />
      <Route element={<AboutUs />} ErrorBoundary={RouterErrorBoundary} path="about-us" />
      <Route element={<Account />} ErrorBoundary={RouterErrorBoundary} path="account" />
      <Route element={<Apply />} ErrorBoundary={RouterErrorBoundary} path="apply" />
      <Route element={<BugReport />} ErrorBoundary={RouterErrorBoundary} path="bug-report" />
      <Route element={<Chat />} ErrorBoundary={RouterErrorBoundary} path="chat" />
      <Route element={<ConfirmPassword />} ErrorBoundary={RouterErrorBoundary} path="confirm-password" />
      <Route element={<ContactUs />} ErrorBoundary={RouterErrorBoundary} path="contact-us" />
      <Route element={<Faq />} ErrorBoundary={RouterErrorBoundary} path="faq" />
      <Route element={<ForgotPassword />} ErrorBoundary={RouterErrorBoundary} path="forgot-password" />
      <Route element={<Privacy />} ErrorBoundary={RouterErrorBoundary} path="privacy" />
      <Route element={<Recs />} ErrorBoundary={RouterErrorBoundary} path="recs" />
      <Route element={<SignIn />} ErrorBoundary={RouterErrorBoundary} path="signin" />
      <Route element={<SignUp />} ErrorBoundary={RouterErrorBoundary} path="signup" />
      <Route element={<Default />} ErrorBoundary={RouterErrorBoundary} path=":dir" />
      <Route element={<Default />} ErrorBoundary={RouterErrorBoundary} path=":dir/:page" />
      <Route element={<Default />} ErrorBoundary={RouterErrorBoundary} path=":dir/:page/:subpage" />
    </Route>
  )
);

const Router = () => <RouterProvider router={router} />;

export default Router;
